import React from 'react';

const Locked = () => <span className="card-icon">L</span>;

export default Locked;
